import { render, staticRenderFns } from "./PersonInput.vue?vue&type=template&id=12fe27a8&scoped=true"
import script from "./PersonInput.vue?vue&type=script&lang=js"
export * from "./PersonInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fe27a8",
  null
  
)

export default component.exports